import * as React from 'react';
import Space from 'antd/lib/space';
import Text from 'antd/lib/typography/Text';

const FilesUsedPopover: React.FC<{ files: { label: string; path: string }[] }> = ({ files }) => (
    <Space direction="vertical" size={8} style={{ maxWidth: 480 }}>
        <Text strong>Files used</Text>
        <Space direction="vertical" size={4}>
            {files.map((file) => (
                <Space key={file.path} direction="vertical" size={0}>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        {file.label}
                    </Text>
                    <Text copyable={{ text: file.path }} style={{ fontSize: 12, wordBreak: 'break-all' }}>
                        {file.path}
                    </Text>
                </Space>
            ))}
        </Space>
    </Space>
);

export default FilesUsedPopover;
